import { AcadNavTabs } from "@components";
import { OrgRoutes as routes } from "./CommunityRoutes";

const CommunityDashboard = () => {
  return <AcadNavTabs routes={routes} />;
};

export default CommunityDashboard;
